import { isList } from '../Lists/isList';
import { reduce } from '../Lists/reduce';
import { isNullOrUndef } from '../Types/isNullOrUndef';
/**
 * Converts a given object/map/set into an array
 * @param list
 * @return {Array}
 */
export function asArray(list) {
    if (isNullOrUndef(list)) {
        return [];
    }
    if (!isList(list)) {
        throw new Error('Could not determine the output type of a given element!');
    }
    return reduce(list, function (l, v) {
        l.push(v);
        return l;
    }, []);
}
//# sourceMappingURL=asArray.js.map